
define('text!views/pages/cash/PaymentMethodTypeInMaintenanceViewModel.html',[],function () { return '<div class="flex-1 flex-vertical absolute-center pad center">\n    <span class="icon icon-32 gutter-bottom-mini icons-alert"></span>\n    <p class="pad">\n        {{{ content.message }}}\n    </p>\n </div>\n';});

